import React, { ReactElement } from "react";
import { EventGridRowModel } from "../../components/EventGrid";
import { TagsInput } from "../../components/TagsInput";

export const useTagsColumn = (
  pauseVideo: () => void
): ((row: EventGridRowModel, disabled?: boolean) => ReactElement) => {
  return (row, disabled = false) => (
    <TagsInput event={row} pauseVideo={pauseVideo} disabled={disabled} />
  );
};
